<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      d="M19.373 6.043a1 1 0 1 0-1.414-1.414L12 10.589 6.04 4.628a1 1 0 0 0-1.414 1.414l5.96 5.96-5.96 5.96a1 1 0 1 0 1.414 1.413l5.96-5.96 5.96 5.96a1 1 0 0 0 1.413-1.414l-5.96-5.96 5.96-5.959Z"
      fill="currentColor" />
  </g>
</svg>
